import { render, staticRenderFns } from "./ContatoModal.vue?vue&type=template&id=0e040d0a&scoped=true"
import script from "./ContatoModal.vue?vue&type=script&lang=js"
export * from "./ContatoModal.vue?vue&type=script&lang=js"
import style0 from "./ContatoModal.vue?vue&type=style&index=0&id=0e040d0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e040d0a",
  null
  
)

export default component.exports